import { useEffect, useRef } from "react";
import { SketchField, Tools } from "@/@corefabriccanvas";
import { PageIcon } from "@/types";

const ShowUserDrawing = ({ userNote }: { userNote: PageIcon }) => {
  const noteSketchRef = useRef<SketchField | null>(null);

  useEffect(() => {
    if (userNote && noteSketchRef && noteSketchRef.current) {
      noteSketchRef.current.fromJSON(userNote.content);
    }
  }, [noteSketchRef, userNote]);

  return (
    <SketchField
      ref={noteSketchRef}
      onChange={() => {}}
      tool={Tools.Pencil}
      lineColor="red"
      lineWidth={10}
      onZoomChange={() => {}}
      height={500}
      width={500}
    />
  );
};

export default ShowUserDrawing;
